import React from 'react'
import { _ } from '@iskytrip/sdk'
import BaseComponent from '@base/BaseComponent'
import CSS from './index.module.css'
import Iconfont from '@components/Iconfont'
import IconCodeEmum from '@components/Iconfont/iconCodeEmum'
import logoDefault from '@assets/images/logoDefault.png'

class Index extends BaseComponent {
	itemPress(item) {
		console.log(item)
		if (this.isGray()) {
			return
		}
		this.props.itemPress && this.props.itemPress(item)
	}

	itemBtnPress(item, e) {
		console.log(item)
		// 阻止事件冒泡
		e.stopPropagation()
		e.nativeEvent.stopImmediatePropagation()
		this.props.itemBtnPress && this.props.itemBtnPress(item)
	}

	isGray() {
		// equityStatus 状态 0:待领取 1:待使用 2:已使用 3:已过期 4:转赠中 5:已转赠 6:已失效 7:已绑定 8:已领完 9:已领取 10:已退款
		const item = this.props.item || {}
		if (
			+item.equityStatus === 2 ||
			+item.equityStatus === 3 ||
			+item.equityStatus === 5 ||
			+item.equityStatus === 6
		) {
			return true
		}
		return false
	}

	render() {
		const rowID = this.props.rowID || ''
		const item = this.props.item || {}
		const style = this.props.style || {}

		let btnComponent = null
		// equityButtonOperation 按钮操作
		// 1:领权益 2:领取优选券 3:去使用优选券 4:已过期 5:已领取 6:已使用 7:去使用 8:待生效 61:跳转中免日上
		if (item.buttonDesc) {
			btnComponent = (
				<p
					className={
						+item.equityButtonOperation === 1 || +item.equityButtonOperation === 2
							? CSS.btnStyle3
							: CSS.btnStyle4
					}
					onClick={this.itemBtnPress.bind(this, item)}
				>
					{item.buttonDesc || ''}
				</p>
			)
		}
		if (item.equityButtonOperation === 8) {
			btnComponent = <p className={CSS.btnStyle4}>{item.buttonDesc || ''}</p>
		}
		if (!this.props.canUse) {
			btnComponent = null
		}
		// btnComponent = <p className={CSS.btnStyle4}>领取</p>

		const isGrayColor = this.isGray()

		return (
			<div
				key={rowID}
				className={CSS.cell}
				style={style}
				onClick={this.itemPress.bind(this, item)}
			>
				<div className={CSS.cellLeft}>
					<img src={item.relationIcon || logoDefault} alt='' />
				</div>
				<div className={CSS.cellMiddle}>
					<p
						className={
							isGrayColor
								? `${CSS.cellMiddleTitle} ${CSS.gray}`
								: `${CSS.cellMiddleTitle}`
						}
					>
						{item.relationName || ''}
					</p>
					<p
						className={
							isGrayColor
								? `${CSS.cellMiddleContent} ${CSS.gray}`
								: `${CSS.cellMiddleContent}`
						}
					>
						{item.relationExpiryDate || ''}
					</p>
					<p
						className={
							isGrayColor
								? `${CSS.cellMiddleRule} ${CSS.gray}`
								: `${CSS.cellMiddleRule}`
						}
					>
						使用规则
						<Iconfont
							className={CSS.iconArrowDown}
							font={IconCodeEmum.ARROW_RIGHT}
							style={{
								fontSize: '.16rem',
								color: '#CCCCCC',
							}}
						/>
					</p>
				</div>
				<div className={CSS.cellRight}>{btnComponent}</div>
				{/*{_.isHasValue(item.equityTagImg) ? (*/}
				{/*	<img className={CSS.cellTagImg1} src={item.equityTagImg || ''} alt='' />*/}
				{/*) : null}*/}
				{_.isHasValue(item.stampImg) ? (
					<img className={CSS.cellTagImg2} src={item.stampImg || ''} alt='' />
				) : null}
			</div>
		)
	}
}

export default Index
